import React from 'react';
import { Card, Descriptions, Typography } from 'antd';
import { isNC2, isHyperV, isOpenShift, isHPEVME, CLOUD_TYPE, isOpenStack } from '../../../constants';

const { Text } = Typography;

export const CloudConfiguration = ({ cloudAccountType, cloudConfiguration }) => {
    let clouds = ['azure_dr', 'vsphere_dr', 'vsphere_offline_replicas'];

    return (
        <>
            {clouds.includes(cloudAccountType) && (
                <>
                    {cloudAccountType !== 'azure_dr' && (
                        <Card title="DR Site vSphere Configuration:" size="small">
                            <Descriptions column={1} size="small">
                                <Descriptions.Item label="vCenter URL">
                                    <Text>{cloudConfiguration.vsphere.url}</Text>
                                </Descriptions.Item>
                                {cloudConfiguration.cloud_info && cloudConfiguration.cloud_info.target && (
                                    <Descriptions.Item label="vCenter version:">
                                        <Text>{cloudConfiguration.cloud_info.target.version}</Text>
                                    </Descriptions.Item>
                                )}
                            </Descriptions>
                        </Card>
                    )}
                    <Card title="Primary Site vSphere Configuration:" size="small">
                        <Descriptions column={1} size="small">
                            <Descriptions.Item label="vCenter URL">
                                <Text>{cloudConfiguration.vsphere.url}</Text>
                            </Descriptions.Item>
                            <Descriptions.Item label="Datacenter">
                                <Text>{cloudConfiguration.vsphere.source_datacenter}</Text>
                            </Descriptions.Item>
                            {cloudConfiguration.cloud_info && cloudConfiguration.cloud_info.target && (
                                <Descriptions.Item label="vCenter version">
                                    <Text>{cloudConfiguration.cloud_info.target.version}</Text>
                                </Descriptions.Item>
                            )}
                        </Descriptions>
                    </Card>
                </>
            )}
            {isNC2(cloudAccountType) && (
                <Card title="Target NC2 Configuration:" size="small">
                    <Descriptions column={1} size="small">
                        <Descriptions.Item label="NC2 URL">
                            <Text>{cloudConfiguration.nc2?.url}</Text>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
            )}
            {isHyperV(cloudAccountType) && (
                <Card title="Hyper-V Configuration:" size="small">
                    <Descriptions column={1} size="small">
                        <Descriptions.Item label="Hyper-V URL">
                            <Text>{cloudConfiguration.hyperv?.url}</Text>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
            )}
            {isOpenShift(cloudAccountType) && (
                <Card title="Target OpenShift Configuration:" size="small">
                    <Descriptions column={1} size="small">
                        <Descriptions.Item label="Target OpenShift URL">
                            <Text>{cloudConfiguration.openshift?.url}</Text>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
            )}
            {isOpenStack(cloudAccountType) && (
                <Card title="Target OpenStack Configuration:" size="small">
                    <Descriptions column={1} size="small">
                        <Descriptions.Item label="Target OpenStack URL">
                            <Text>{cloudConfiguration.openstack?.url}</Text>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
            )}
            {isHPEVME(cloudAccountType) && (
                <Card title="Target HPE VM Essentials Configuration:" size="small">
                    <Descriptions column={1} size="small">
                        <Descriptions.Item label="Target HPE VM Essentials URL">
                            <Text>{cloudConfiguration.hpe_vme?.url}</Text>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
            )}
            {![
                CLOUD_TYPE.NC2,
                CLOUD_TYPE.HPE_VME,
                CLOUD_TYPE.OPENSHIFT,
                CLOUD_TYPE.OPENSTACK,
                CLOUD_TYPE.HYPERV,
            ].includes(cloudAccountType) && (
                <Card title="Target vSphere Configuration:" size="small">
                    <Descriptions column={1} size="small">
                        <Descriptions.Item label="Target vCenter URL">
                            <Text>{cloudConfiguration.vsphere?.url}</Text>
                        </Descriptions.Item>
                        {cloudConfiguration.cloud_info && cloudConfiguration.cloud_info?.target && (
                            <Descriptions.Item label="vCenter version">
                                <Text>{cloudConfiguration.cloud_info.target?.version}</Text>
                            </Descriptions.Item>
                        )}
                    </Descriptions>
                </Card>
            )}
        </>
    );
};
